import React, { Component } from 'react';
import {connect} from "react-redux";

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import PrimaryButton from "../Components/PrimaryButton";
import TextArea from "../Components/TextArea";
import TextField from "../Components/TextField";
import {setGiftSender, setNote} from "../Actions";
import {withRouter} from "react-router-dom";
import ParagraphText from "../Components/ParagraphText";
import TopContent from "../Components/TopContent";

const ORIGINAL_NOTE = 'Joe,\n\nWelcome to Bitcoin!\n\nAnn';

class PersonalizePage extends Component {
  componentDidMount() {
    if(this.props.wallet.address) {
      return this.props.history.push('/verify');
    }

    if(!this.props.note) {
      this.props.dispatch(setNote({
        note: ORIGINAL_NOTE,
      }));
    }
  }
  handleKeyPress (e) {
    if (e.key === 'Enter') {
      this.onBlur(e);
    }
  }
  onBlur(event) {
    const typedSender = event.target.value;
    this.props.dispatch(setGiftSender({
      senderEmail: typedSender
    }));
  }
  noteChange(event) {
    const typedNote = event.target.value;
    this.props.dispatch(setNote({
      note: typedNote
    }));
  }
  clearPlaceholder() {
    if(this.props.note === ORIGINAL_NOTE) {
      this.props.dispatch(setNote({
        note: '',
      }));
    }
  }
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Note</TitleText>
              <div className="spacer-20px" />
              <ParagraphText>Write a note:</ParagraphText>

              <TextArea value={this.props.note} onFocus={() => this.clearPlaceholder()} onChange={e => this.noteChange(e)}>{this.props.note}</TextArea>
              <div className="spacer-20px" />
              <ParagraphText>Your email:</ParagraphText>
              <TextField
                type="email"
                placeholder="ann.coins@gmail.com"
                onKeyPress={(e) => this.handleKeyPress(e)}
                onBlur={(e) => this.onBlur(e)}
                defaultValue={this.props.senderEmail}
              />
              <div className="spacer-20px" />
              <PrimaryButton to="/verify" styles={'align-self: center;'}>Verify →</PrimaryButton>
              <div className="spacer-40px" />
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  senderEmail: state.gift.senderEmail,
  note: state.gift.note,
  wallet: state.wallet
});

export default connect(mapStateToProps)(withRouter(PersonalizePage));



// WEBPACK FOOTER //
// ./src/Pages/PersonalizePage.js